// extracted by mini-css-extract-plugin
export default {"back_btn":"styles_back_btn__444ip","action_button":"styles_action_button__MaxgT","collapse":"styles_collapse__C5I-U"};